<template>
  <ul
    :class="{
      'whitespace-nowrap text-8px font-semibold uppercase': true,
      'flex flex-wrap gap-2.5': variant === 'badge',
      'inline-flex flex-wrap gap-0.5': variant === 'inline',
    }"
    data-testid="Taxonomies"
  >
    <template
      v-for="(item, index) in taxonomies"
      :key="item._id"
    >
      <li class="inline">
        <!-- TODO: handle category/tag resource center query params -->
        <PTCLink
          v-if="linkType === 'link'"
          :to="linkToResourceCenter({ slug: item.slug.current, contentType })"
          :class="{
            'inline-block max-w-52 overflow-hidden text-ellipsis whitespace-nowrap leading-[0.625rem] tracking-wider hover:underline': true,
            'rounded-[5px] bg-www-color-neutral-very-light px-5px py-0.5': variant === 'badge',
          }"
        >
          {{ item.prefLabel }}
        </PTCLink>
        <span
          v-if="linkType === 'event'"
          :class="{
            'inline-block max-w-52 overflow-hidden text-ellipsis whitespace-nowrap leading-[0.625rem] tracking-wider': true,
            'rounded-[5px] bg-www-color-neutral-very-light px-5px py-0.5': variant === 'badge',
            'hover:cursor-pointer hover:bg-www-color-primary-lighter': true,
          }"
          @click="
            scrollToTop();
            emitChange({
              id: item._id,
              slug: item.slug?.current || `slug-not-set for ${item._id}`,
              isChecked: true,
            });
          "
        >
          {{ item.prefLabel }}
        </span>

        <template v-if="variant === 'inline' && index !== taxonomies.length - 1">,</template>
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
import type { SupportedResourceLinkType } from '~/utils/taxonomiesURL';

type Variant = 'badge' | 'inline';

interface Props {
  taxonomies: CardTaxonomies;
  contentType?: SupportedResourceLinkType;
  variant?: Variant;
  linkType: 'link' | 'event';
}

withDefaults(defineProps<Props>(), {
  variant: 'badge',
  contentType: undefined,
});

const emit = defineEmits<{
  (_evt: 'taxonomyChange', _payload: TaxonomyChangedPayload): void;
}>();

const emitChange = (payload: TaxonomyChangedPayload) => {
  emit('taxonomyChange', payload);
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
</script>
